import React from "react";
import { Container } from "react-bootstrap";
import { TableHeader } from "@services/ui-components";
import { useTranslation } from "react-i18next";
import { useReactiveVar } from "@apollo/client";
import PaymentHistoryAndManagementTable from "./PaymentHistoryAndManagementTable";
import Spinner from "@services/ui-components/src/Spinner/Spinner";
import { useParams } from "react-router-dom";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";

const PaymentHistoryAndManagement = () => {
    const { t } = useTranslation();
    const { branchId } = useParams();
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);

    if (!currentCompanyId) return <Spinner />;

    return (
        <Container fluid className="mb-9 mx-0 px-2 px-lg-0">
            <TableHeader
                title={t("History and Payment Management")}
                paths={[
                    {
                        path: `/payment/history/company/${currentCompanyId}/${branchId}`,
                        label: t("Management of Tariffs"),
                    },
                    {
                        path: `/payment/history/company/${currentCompanyId}/${branchId}`,
                        label: t("History and Payment Management"),
                    },
                ]}
            />
            <PaymentHistoryAndManagementTable />
        </Container>
    );
};

export default PaymentHistoryAndManagement;
